import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class AppRoleGuard implements CanActivate, CanActivateChild {
  constructor(
    private authService: AuthService,
    private router: Router,
    private messageService: NzMessageService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return this.guardHandler(state, route);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return this.guardHandler(state, childRoute);
  }

  guardHandler(
    state: RouterStateSnapshot,
    route: ActivatedRouteSnapshot
  ): boolean {
    const { role } = this.authService.user || {};
    const appRoles = route.data['appRole'] || [];
    const hasAccess = appRoles.includes(role);

    if (!hasAccess) {
      this.router.navigate(['/']);
      this.messageService.error('You do not have access to view this resource');
      return false;
    }
    return true;
  }
}
